// import { EuiCard, EuiFlexGroup, EuiFlexItem, EuiIcon } from "@elastic/eui"
import { Card } from "antd"
import { FC } from "react"

const Dashboard: FC = () => {
  return <Card>Dashboard</Card>
}

export default Dashboard
